import * as types from "./mutation-types";
import { usersService } from "@/services";
import { messageHelper } from "@/helpers/message_helper";

export const fetchUserList = async ({ commit }, queryParams) => {
  commit(types.SET_IS_LOADING, true);

  try {
    const response = await usersService.list(queryParams);
    commit(types.SET_USER_LIST, response.data.data);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  } finally {
    commit(types.SET_IS_LOADING, false);
  }
};

// eslint-disable-next-line no-unused-vars
export const getUserById = async ({ commit }, userId) => {
  let user = {};

  try {
    const response = await usersService.getById(userId);
    user = response.data.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return user;
};

export const createUser = async ({ commit }, payload) => {
  try {
    const response = await usersService.create(payload);
    commit(types.USER_LIST_ADD_ITEM, response.data.data);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }
};

// eslint-disable-next-line no-unused-vars
export const updateUser = async ({ commit }, payload) => {
  let user = null;

  try {
    const response = await usersService.update(payload);
    user = response.data.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return user;
};

export const removeUser = async ({ commit }, id) => {
  try {
    await usersService.destroy(id);
    commit(types.USER_LIST_REMOVE_ITEM, id);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }
};

// eslint-disable-next-line no-unused-vars
export const getAccessLogsById = async ({ commit }, params) => {
  let events = {};

  try {
    const response = await usersService.getAccessLogsById(params);
    events = response.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return events;
};
